import { render, staticRenderFns } from "./FiringAlertsCard.vue?vue&type=template&id=1f27b6c4&scoped=true&"
import script from "./FiringAlertsCard.vue?vue&type=script&lang=js&"
export * from "./FiringAlertsCard.vue?vue&type=script&lang=js&"
import style0 from "./FiringAlertsCard.vue?vue&type=style&index=0&id=1f27b6c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f27b6c4",
  null
  
)

export default component.exports